module.exports = __webpack_public_path__ + "static/media/DQ-forAll.76dd2edd.png";